// Centralized rally cross-selling ticket types

const ticketTypesRallyCrossSelling = {
    eventGroupId: 3553,
    items: [
        {
            id: 1,
            price: 60.00,
            oldPrice: 75.00,
            currency: "CHF",
            quantity: 12,
            externalTicketCode: "city rally regular tour",
            info: {
                name: {
                    de: "Teamticket Regular Tour (3-5 Personen)",
                    fr: "TEAMTICKET REGULAR TOUR (Équipe: 3-5 personnes)",
                    en: "Team ticket Regular Tour (3 - 5 people)",
                    it: "Team ticket Regular Tour (3 - 5 people)",
                }
            },
        },
        {
            id: 2,
            price: 41.60,
            oldPrice: 52.00,
            currency: "CHF",
            quantity: 12,
            externalTicketCode: "city rally shortcut tour",
            info: {
                name: {
                    de: "Teamticket Shortcut Tour (3-5 Personen)",
                    fr: "TEAMTICKET SHORTCUT TOUR (Équipe: 3-5 personnes)",
                    en: "Team ticket Shortcut Tour (3 - 5 people)",
                    it: "Team ticket Shortcut Tour (3 - 5 people)"
                }
            },
        }
    ]
};

export default ticketTypesRallyCrossSelling;
